import TabPage from "./../factories/tab-page";
import BaseViewModel from "./../factories/base-view-model2";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import TabController from "./../factories/tab-controller";
import BaoDialog from "./../factories/bao-dialog";
class PurchaseVendor extends BaseViewModel {
    public PurchaseVendorArtikelTab: TabPage;
    PurchaseVendorName: KnockoutObservable<string> = ko.observable("");
    constructor(tabPage: TabPage) {
        super(tabPage);
    }
    CompleteCheck() {
        var isComplete: boolean = true;
        if (Bao.Utils.String.IsNullOrEmpty(this.PurchaseVendorName())) {
            isComplete = false;
        }
        if (!isComplete) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    }
    InitUrl() {
        return "PurchaseVendor/Init";
    }
    public initTabs() {
        return super.InitTabController().then(() => {
            this.PurchaseVendorArtikelTab = new TabPage();
            this.PurchaseVendorArtikelTab.IsClosable(false);
            this.PurchaseVendorArtikelTab.Url("PurchaseVendorArtikelTab");
            this.TabController.AddTab(this.PurchaseVendorArtikelTab);
        });
    }
    public init(): JQueryPromise<void> {
        let def = $.Deferred<void>();
        $.when(super.init(), this.initTabs()).then(() => {
            def.resolve();
        });
        return def.promise();
    }
    loaded() {
        super.loaded();
    }
}
export default PurchaseVendor;